export const MOCKED_ORGANIZATION_ID = '001VX00000JDDm5YAH';
export const DEFAULT_CURRENCY = {
  code: 'USD',
  symbol: '$',
};

export const ABOUTSIB_URL = 'https://www.aboutsib.com/';
export const PRIVACY_POLICY_URL = 'https://www.aboutsib.com/privacy/';
export const TERMS_OF_USE_URL = 'https://www.aboutsib.com/terms/';
export const SPENDBRAIN_LEARN_MORE_URL = 'https://www.aboutsib.com/spendbrain/';
export const PAYMENT_URL = 'https://vector97.com/make-a-payment/';

export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const DEFAULT_VIDEO_URL =
  'https://www.youtube.com/embed/GK0nrDMl3Ic?si=yPOI1WX8V5wNFqSQ';

export const spendAreaCategoryVideos: Record<
  string,
  { category: string; videoUrl: string }[]
> = {
  Taxes: [
    {
      category: 'Business Personal Property',
      videoUrl: 'https://www.youtube.com/embed/GJ3u2nmMPlc?si=qANCFtV68h_7er7f',
    },
    {
      category: 'Property Tax',
      videoUrl: 'https://www.youtube.com/embed/4-hU5nLmoFE?si=_ZETks9LxlYVh7WY',
    },
  ],
  Healthcare: [
    {
      category: 'Medical Supplies / Equipment',
      videoUrl: 'https://www.youtube.com/embed/denaVffCYz4?si=ZDlZHU1VKQKP1FOG',
    },
  ],
  Alarm: [
    {
      category: 'Alarm',
      videoUrl: 'https://www.youtube.com/embed/BaGAdXfu3PA?si=cjZHWtGH7RJrooey',
    },
  ],
  'Document Storage': [
    {
      category: 'Document Storage',
      videoUrl: 'https://www.youtube.com/embed/6KlgbIqXUmE?si=tP_TaFN8TUPFefAg',
    },
  ],
  'IT / Telecom': [
    {
      category: 'Cloud',
      videoUrl: 'https://www.youtube.com/embed/t1jhPCml53U?si=XpCs3fkXSVr9-eut',
    },
    {
      category: 'Phone / Internet',
      videoUrl: 'https://www.youtube.com/embed/_5V2pg7cbsA?si=OHhRwD6o4a9ORZ8U',
    },
    {
      category: 'Printer / Copier',
      videoUrl: 'https://www.youtube.com/embed/ST-GqXWGtxs?si=RRw49PbqBE62WjAw',
    },
    {
      category: 'SaaS',
      videoUrl: 'https://www.youtube.com/embed/i7z1f_AsAA4?si=zNF7LmxTOuaZpjS1',
    },
    {
      category: 'Wireless Phones / Devices',
      videoUrl: 'https://www.youtube.com/embed/Bs2bguDmSm0?si=irQaxVEzE9XKXVnl',
    },
  ],
  Treasury: [
    {
      category: 'Bank Fees',
      videoUrl: 'https://www.youtube.com/embed/VQEK3Jgbt-c?si=OktX49-wlbNwUofq',
    },
  ],
  Maintenance: [
    {
      category: 'Elevator / Escalator',
      videoUrl: 'https://www.youtube.com/embed/4P_GsDNMsyM?si=X_KVRzCwhuX4BZzE',
    },
  ],
  Supplies: [
    {
      category: 'Food Costs',
      videoUrl: 'https://www.youtube.com/embed/YRXrNaN0aqU?si=GUxuCKTYHU0UWhrm',
    },
  ],
  Utilities: [
    {
      category: 'Heating Oil',
      videoUrl: 'https://www.youtube.com/embed/hcmNArjzbQE?si=UIKX1sc96WtnZiEu',
    },
    {
      category: 'Liquid Propane',
      videoUrl: 'https://www.youtube.com/embed/eRz-jfZossE?si=RfNFzBrTTZpdhM59',
    },
  ],
  'Human Resources': [
    {
      category: 'HR Software',
      videoUrl: 'https://www.youtube.com/embed/vsT5Rah_bH4?si=82wU9L0-6VYqut4i',
    },
    {
      category: 'Payroll Service',
      videoUrl: 'https://www.youtube.com/embed/cwIYvqShG9o?si=-XX6Xgrd0tblf9MS',
    },
    {
      category: 'Staffing',
      videoUrl: 'https://www.youtube.com/embed/DDi52Mb1Y4Q?si=7-4pSJkHHY4pFy8q',
    },
  ],
  Textiles: [
    {
      category: 'Laundry Service',
      videoUrl: 'https://www.youtube.com/embed/FaxHLBjF610?si=5YXgB84xbRvVCjdK',
    },
  ],
};
export const MEDIA_SM_QUERY = '(max-width: 640px)';

export enum BadgeLocation {
  SIDE_PANEL = 'side_panel',
  LOGIN_PAGE = 'login_page',
}

export const NO_DATA_PLACEHOLDER = '-';
